/*
 * Collection view for conversation transcripts
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/learner/learnerTranscriptModal/conversationTranscript/template/conversationTranscriptTemplate.html",
  "modules/learner/learnerTranscriptModal/conversationTranscript/template/conversationTurnTemplate.html",
], function (Marionette, Messenger, ConversationTranscriptTemplate, ConversationTurnTemplate) {
  var ConversationTranscriptView = {};

  ConversationTranscriptView.conversationTurnView = Marionette.ItemView.extend({
    template: ConversationTurnTemplate,
    tagName: "tr",
    templateHelpers: {
      getTimeDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:time", date);
      },
    },
  });

  ConversationTranscriptView.conversationTranscriptView = Marionette.CompositeView.extend({
    itemView: ConversationTranscriptView.conversationTurnView,
    itemViewContainer: "tbody",
    template: ConversationTranscriptTemplate,
    initialize: function (options) {
      this.turn = options.turn;
    },
    itemViewOptions: function (model) {
      var className = "";
      if (model.get("turnCount") === this.turn && model.get("turnIndicator") === "U") {
        className = "info";
      }
      return {
        className: className,
      };
    },
  });

  return ConversationTranscriptView;
});
